import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import * as actions from '../../actions/index';

import './HorizontalSubNav.css';

const HorizontalSubNav = props => {
  function onClick(sectionIndex, groupIndex, stageIndex) {
    props.goToSection(sectionIndex);
    props.goToGroup(groupIndex);
    props.goToStage(stageIndex);
  }
  return (
    <nav className="horizontalSubNav">
      {
        props.data.map((item, pos) => (
          <span key={'subNavLink'+pos}>
            <a
              className={'horizontalSubNav__item ' + (props.currentStage === pos ? ' isActive' : '')}
              onClick={() => onClick(props.currentSection, props.currentGroup, pos)}>
              {item.subnav || item.title}
            </a>
            { pos < (props.data.length - 1) &&
              <img className="arrow" alt="" src="./assets/ui/iconArrow.png" />
            }
          </span>
        ))
      }
    </nav>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    goToStage: (stageID) => {
      dispatch(actions.goToStage(stageID));
    },
    goToGroup: (groupID) => {
      dispatch(actions.goToGroup(groupID));
    },
    goToSection: (sectionID) => {
      dispatch(actions.goToSection(sectionID));
    }
  };
}

HorizontalSubNav.propTypes = {
  data: propTypes.array.isRequired,
  goToStage: propTypes.func.isRequired,
  goToSection: propTypes.func.isRequired,
  goToGroup: propTypes.func.isRequired,
  currentGroup: propTypes.number.isRequired,
  currentStage: propTypes.number.isRequired,
  currentSection: propTypes.number.isRequired,
};

export default connect(null, mapDispatchToProps)(HorizontalSubNav);



// WEBPACK FOOTER //
// ./src/components/HorizontalSubNav/HorizontalSubNav.js